module.exports = "//static.hsappstatic.net/growth-onboarding-confetti/static-1.633/images/sprocket.svg"